import { render } from "./Comment.svg?vue&type=template&id=4c3155da"
const script = {}
script.render = render

export default script